export default __webpack_public_path__ + "static/media/dani.4a1ce1af.png";